export default "__VITE_ASSET__30826a80__"